module.exports = __webpack_public_path__ + "static/media/h_scene.0504cae9.jpg";